<template>
  <div class="cs-container">
    <div class="error-page">
      <div class="text-center error-page__container">
        <h1 class="error-page__title">페이지를 찾을 수 없습니다.</h1>
        <p class="mt-2 error-page__desc">
          링크를 클릭하여 시작 페이지로 이동합니다.
          <a class="ml-2 underline error-page__link" href="/client/estimate">이동하기</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
.error-page {
  display: flex;
  height: calc(100vh - 160px);

  &__container {
    // max-width: 700px;
    // width: 700px;
    margin: auto;
  }

  &__icon {
    font-size: 6rem;
    color: var(--theme-color-font-danger);
  }
  &__404 {
    font-size: 8rem;
    font-weight: 800;
    color: var(--theme-color-font-danger);
  }
  &__title {
    font-size: 2.5rem;
    font-weight: 700;
  }
  &__desc {
    color: var(--theme-color-font-desc);
  }
  &__link {
    color: var(--theme-color-font-second);
  }
}
</style>
